<template>
  <div class="container-fluid">
   <h1 class="text-center mt-5">صفحه یافت نشد</h1>
  </div>
</template>

<script>

import { mapGetters } from "vuex";

export default {
  name: "page-not-found-component",
  components: {
   
  },

  computed: {
    ...mapGetters({
      categories: "categories",
    }),
  },

  watch: {},

  mounted() {
   
  },

  methods: {
    

    
  },

  data() {
    return {
      
    };
  },
};
</script>

<style lang="scss">
.sidebar {
  background: #f6f6f6;
}
</style>


